import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for select style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiSelectStyle = (theme: Theme): ThemeStyle => {
  return {
    select: {
      padding: 0,
      '&:focus': {
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.common.white,
      },
    },
  };
};
